/** Target on-screen zoom factor when hovering a card image (list + canvas). */
export const CARD_IMAGE_HOVER_ZOOM = 2.5;

/**
 * Dwell before canvas/list image hover zoom + HQ tier upgrade.
 * Filters cursor pass-overs that are not intentional screenshot inspection.
 */
export const CARD_IMAGE_HOVER_ENTER_DELAY_MS = 180;

/** Minimum grid / canvas zoom level. */
export const CARD_VIEW_ZOOM_MIN = 0.2;

/** Step size for grid / canvas zoom controls. */
export const CARD_VIEW_ZOOM_STEP = 0.25;

/**
 * Max canvas zoom equals hover zoom: beyond this, card images cannot zoom further on hover.
 * Also used as the list grid zoom ceiling.
 */
export const CARD_VIEW_ZOOM_MAX = CARD_IMAGE_HOVER_ZOOM;

function roundZoom(value) {
  return Math.round(value * 100) / 100;
}

export const CARD_VIEW_ZOOM_STEPS = (() => {
  const steps = [];
  for (
    let zoom = CARD_VIEW_ZOOM_MIN;
    zoom <= CARD_VIEW_ZOOM_MAX + 1e-6;
    zoom += CARD_VIEW_ZOOM_STEP
  ) {
    steps.push(roundZoom(zoom));
  }
  const last = steps[steps.length - 1];
  if (last !== CARD_VIEW_ZOOM_MAX) {
    steps.push(CARD_VIEW_ZOOM_MAX);
  }
  return steps;
})();

/**
 * Canvas camera zoom steps for +/- controls.
 * Geometric-ish spacing (includes 1) so each step animates a smaller visual jump.
 */
export const CANVAS_CAMERA_ZOOM_STEPS = [
  0.2, 0.25, 0.35, 0.5, 0.65, 0.8, 1, 1.25, 1.5, 1.85, 2.25, 2.5,
];

export function clampCardViewZoom(zoom) {
  if (!Number.isFinite(zoom)) return 1;
  return Math.min(CARD_VIEW_ZOOM_MAX, Math.max(CARD_VIEW_ZOOM_MIN, zoom));
}

/**
 * CSS transform scale for card image hover.
 * `inverseZoom` compensates for container/camera zoom so screen size stays at CARD_IMAGE_HOVER_ZOOM.
 */
export function getCardImageHoverScale(type, inverseZoom = 1) {
  if (type === 'CANVAS') {
    return inverseZoom;
  }
  return inverseZoom * CARD_IMAGE_HOVER_ZOOM;
}
